import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import { toast } from "react-toastify";
import ticketStore from "../../../Stores/TicketStores";
import TicketConstants from "../../../Constants/TicketConstants";
import TicketActions from "../../../Actions/TicketActions";
import FormTicketRaise from "../../../Components/Equipment-Details/FormTicketRaise";
import {
  getGridSingleSelectOperators,
  GridActionsCellItem,
} from "@mui/x-data-grid-pro";
import TicketDetails from "../../ManageTicket/TicketDetails";
import {
  useEquipGrpPublicInfoActionsContext,
  useEquipGrpPublicInfoContext,
} from "../../../Context/EquipGroupPublicInfoContext";
import { Button } from "@mui/material";

function Tickets(props) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const equipGroupPublicWebConf = useEquipGrpPublicInfoContext();
  const getEquipmentGroupPublicInfo = useEquipGrpPublicInfoActionsContext();
  const location = useLocation();
  const { anlageid, isFunctionCall, handleTourGuid } = props;
  const [showticketDetails, setShowticketDetails] = useState(false);
  const [selTicketId, setSelTicketId] = useState("");
  const [selectedTicketStatus, setSelectedTicketStatus] = useState("");
  const [isMaxTicketLimitReach, setIsMaxTicketLimitReach] = useState(false);
  const [openTicketModal, setOpenTicketModal] = useState(false);

  const [tableData, settableData] = useState([]);
  const columns = [
    {
      field: "title",
      headerName: localization.title,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    {
      field: "status",
      headerName: localization.Status,
      hideable: false,
      flex: 1,
      type: "singleSelect",
      renderCell: (params) => {
        return renderStatus(params.row.status);
      },
      filterOperators: getGridSingleSelectOperators(),
      valueOptions: [
        { value: "Open", label: localization.open },
        { value: "Close", label: localization.close },
        { value: "InProgress", label: localization.inprogress },
      ],
    },
    {
      field: "priority",
      headerName: localization.priority,
      hideable: false,
      flex: 1,
      type: "singleSelect",
      renderCell: (params) => {
        return renderPriority(params.row.priority);
      },
      filterOperators: getGridSingleSelectOperators(),
      valueOptions: [
        { value: "Low", label: localization.low },
        { value: "Medium", label: localization.medium },
        { value: "High", label: localization.high },
      ],
    },
    {
      field: "createdOn",
      headerName: localization.createdOn,
      hideable: false,
      flex: 1,
    },
  ];

  const renderStatus = (Status) => {
    return Status.toLowerCase() === "open"
      ? localization.open
      : Status.toLowerCase() === "close"
        ? localization.close
        : localization.inprogress;
  };

  const renderPriority = (priorityValue) => {
    let content = "";
    let priority =
      priorityValue.toLowerCase() === "high"
        ? localization.high
        : priorityValue.toLowerCase() === "low"
          ? localization.low
          : localization.medium;
    switch (priorityValue) {
      case "Low":
        content = (
          <div className="priorityClsForTicketList lowPriority">{priority}</div>
        );
        break;
      case "Medium":
        content = (
          <div className="priorityClsForTicketList mediumPriority">
            {priority}
          </div>
        );
        break;
      case "High":
        content = (
          <div className="priorityClsForTicketList highPriority">
            {priority}
          </div>
        );
        break;
      default:
        break;
    }
    return content;
  };

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.viewDetail}
        showInMenu
        onClick={() => {
          setSelTicketId(params.row.id);
          setSelectedTicketStatus(params.row.status);
          setShowticketDetails(true);
        }}
      />,
    );
    return _acionList;
  }

  const handleCloseDetails = () => {
    setShowticketDetails(false);
  };

  const getTicketAfterUpdate = () => {
    getEquipmentGroupPublicInfo(anlageid);
    TicketActions.getEquipmentTickets(anlageid);
  };

  useEffect(() => {
    if (anlageid) {
      TicketActions.getEquipmentTickets(anlageid);
      getEquipmentGroupPublicInfo(anlageid);
    }
    return () => {};
  }, [anlageid]);

  useEffect(() => {
    if (
      equipGroupPublicWebConf.openTicketsCount >=
      equipGroupPublicWebConf.openTicketLimit
    ) {
      setIsMaxTicketLimitReach(true);
    } else {
      setIsMaxTicketLimitReach(false);
    }
    return () => {};
  }, [equipGroupPublicWebConf]);

  useEffect(() => {
    function getEquipmentTicketSuccess() {
      var res = ticketStore.getResult();
      if (res) {
        settableData(res);
      }
      handleTourGuid(8);
      setGlobalSpinner(false);
    }

    function getEquipmentTicketFailure() {
      var res = ticketStore.getResult();
      settableData([]);
      setGlobalSpinner(false);
    }

    ticketStore.addChangeListener(
      TicketConstants.GET_EQUIPMENT_TICKET_SUCCESS,
      getEquipmentTicketSuccess,
    );

    ticketStore.addChangeListener(
      TicketConstants.GET_EQUIPMENT_TICKET_FAILURE,
      getEquipmentTicketFailure,
    );

    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.GET_EQUIPMENT_TICKET_SUCCESS,
        getEquipmentTicketSuccess,
      );

      ticketStore.removeChangeListener(
        TicketConstants.GET_EQUIPMENT_TICKET_FAILURE,
        getEquipmentTicketFailure,
      );
    };
  }, []);

  const handleSubmitCallback = () => {
    setOpenTicketModal(false);
    setGlobalSpinner(true);
    TicketActions.getEquipmentTickets(anlageid);
  };

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <div className="">
            <Typography gutterBottom variant="h4" component="div">
              {localization.tableTitle}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {localization.maintenanceAndServiceTickets}
            </Typography>
          </div>
          {!isMaxTicketLimitReach && (
            <div>
              <Button
                variant="contained"
                className="containedBtnCls"
                sx={{ textTransform: "none" }}
                size="large"
                onClick={() => {
                  setOpenTicketModal(true);
                }}
              >
                {localization.ticketCreate}
              </Button>
            </div>
          )}
        </div>
        <div className="w-100">
          <CustomDataGrid
            columns={columns}
            rows={tableData}
            operations={{}}
            onAdd={{}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[]}
            showCheckBox={false}
            gridTableHeight={"dataGridLarge"}
          />
        </div>
      </div>
      {showticketDetails && (
        <TicketDetails
          selTicketId={selTicketId}
          handleClose={handleCloseDetails}
          getTicketAfterUpdate={getTicketAfterUpdate}
          state={selectedTicketStatus}
        />
      )}
      {openTicketModal && (
        <FormTicketRaise
          open={openTicketModal}
          handleClose={() => setOpenTicketModal(false)}
          equipGroupPublicWebConf={equipGroupPublicWebConf}
          anlageid={anlageid}
          handleSubmitCallback={handleSubmitCallback}
        />
      )}
    </>
  );
}
export default Tickets;
